exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".title {\n    position: absolute;\n    background: white;\n    height: 15px;\n    margin-top: -12px;\n    margin-left: 10px;\n    padding: 0 10px;\n }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/course-view/course-view.component.css
// module id = 396
// module chunks = 0